export default "__VITE_ASSET__BZyCMKKT__"